import React, { type ForwardedRef, type HTMLAttributes, type ReactNode } from 'react';
import { css } from 'styled-components';

type FlightPageContentSectionProps = {
  children: ReactNode;
  sectionRef?: ForwardedRef<HTMLElement>;
} & HTMLAttributes<HTMLElement>;

export function TransportPageContentSection(props: FlightPageContentSectionProps) {
  const { children, sectionRef, ...rest } = props;

  return (
    <section
      {...rest}
      css={css`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      ref={sectionRef}
    >
      {children}
    </section>
  );
}

export default TransportPageContentSection;
